import { LayerType } from "../../types";
import { EnvironmentalPermitsSummary } from "./EnvironmentalPermitsSummary";

const ENVIRONMENTAL_PERMITS_SUMMARY_LAYER_TYPE_ID = "ENVIRONMENTAL_PERMITS_SUMMARY_LAYER_TYPE_ID";

export const EnvironmentalPermitsSummaryLayerType: LayerType = {
  id: ENVIRONMENTAL_PERMITS_SUMMARY_LAYER_TYPE_ID,
  LayerSummary: EnvironmentalPermitsSummary,
};
